import { useCallback } from "react";

import { DefinedEntity } from "@formant/core/model/DefinedEntity";
import { IView } from "@formant/core/model/IView";
import { Uuid } from "@formant/core/model/Uuid";

import { useStores } from "../../../context/StoreContext";

export function useViewReorderingCallbacks(views: DefinedEntity<IView>[]) {
    const { viewStore } = useStores();

    const handleMoveToStart = useCallback(
        async (id: Uuid) => {
            const first = views[0];
            await viewStore.reorder(id, "before", first.id);
        },
        [viewStore, views],
    );

    const handleMoveToEnd = useCallback(
        async (id: Uuid) => {
            const last = views[views.length - 1];
            await viewStore.reorder(id, "after", last.id);
        },
        [viewStore, views],
    );

    const handleMoveLeft = useCallback(
        async (id: Uuid) => {
            const idx = views.findIndex(it => it.id === id);
            const previous = views[idx - 1];
            if (!previous) {
                return;
            }
            await viewStore.reorder(id, "before", previous.id);
        },
        [viewStore, views],
    );

    const handleMoveRight = useCallback(
        async (id: Uuid) => {
            const idx = views.findIndex(it => it.id === id);
            const next = views[idx + 1];
            if (!next) {
                return;
            }
            await viewStore.reorder(id, "after", next.id);
        },
        [viewStore, views],
    );

    return {
        handleMoveToStart,
        handleMoveToEnd,
        handleMoveLeft,
        handleMoveRight,
    };
}
